import React from 'react';
import INewJobServiceAgreementModalProps from './WidgetConfigurationDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import WidgetConfigurationContent from './WidgetConfigurationContent';
import { useSaveDashboardWidgetConfiguration, useSetDashboardLayoutWidgetsQueryData } from 'api/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { Inline, objectify } from 'api/utils';

const WidgetConfigurationDialog = (props: INewJobServiceAgreementModalProps) => {
    const {
        open,
        handleClose,
        widgetId,
        widgetType,
        selectedDashboardType,
        selectedWidget,
        selectedDashboardId
    } = props;
    const widgetConfigurationContentInnerRef = React.useRef(null);
    const { mutateAsync: saveDashboardWidgetConfigurationMutateAsync, isLoading: isProcessing } = useSaveDashboardWidgetConfiguration();
    const setDashboardLayoutWidgetsQueryData = useSetDashboardLayoutWidgetsQueryData();

    function getModalContent(): JSX.Element {

        return <WidgetConfigurationContent innerRef={widgetConfigurationContentInnerRef} selectedWidget={selectedWidget} widgetId={widgetId} widgetType={widgetType} selectedDashboardType={selectedDashboardType} />;
    }

    return (
        <FormViewModal
            open={open}
            loading={false}
            title={`${widgetType || ''} Widget Configuration`}
            dialogStyles={{
                width: '900px',
                minHeight: 580,
                maxHeight: 580,
                height: '100%'
            }}
            dialogActionsButtons={true}
            dialogActionsShadow={false}
            modalContent={getModalContent()}
            actions={[
                {
                    title: 'Save',
                    isDefault: true,
                    disabled: isProcessing,
                    listener: async () => {
                        console.log('Save clicked', widgetConfigurationContentInnerRef?.current.getDisplayFieldsGridData());
                        const filteredDashboardWidgetFields = widgetConfigurationContentInnerRef?.current.getDisplayFieldsGridData()?.map(({ WidgetFieldId, Sequence }) => ({
                            WidgetFieldId,
                            Sequence
                        }));

                        const response = await saveDashboardWidgetConfigurationMutateAsync({
                            DashboardWidgetId: Number(widgetId),
                            DashboardWidgetFields: filteredDashboardWidgetFields,
                            Title: widgetConfigurationContentInnerRef?.current.getTextFieldsData()?.WidgetTitle,
                            MaximumDisplayRows: widgetType?.toLowerCase().includes('grid') ? (widgetConfigurationContentInnerRef?.current.getTextFieldsData()?.MaxDisplayRow || 0) : undefined,
                        });

                        console.log('response', response);

                        if (response?.Status) {
                            setDashboardLayoutWidgetsQueryData(Number(selectedDashboardId), {
                                DashboardWidgets: response?.DashboardWidgets?.map((o) => objectify(o as Inline<any>)) || [],
                                Status: response?.Status
                            });
                            if (handleClose) {
                                handleClose();
                            }
                        }
                    },
                },
                {
                    title: 'Cancel',
                    listener: () => {
                        if (handleClose) {
                            handleClose();
                        }
                    },
                },
            ]}
        />
    );
};

export default WidgetConfigurationDialog;
